import { Controller } from "@hotwired/stimulus"
import { TurboBeforeFetchRequestEvent } from "@hotwired/turbo"
import Confirmation from "../../confirmation"

export default class SettingsController extends Controller {
  async confirmTransfer(event: TurboBeforeFetchRequestEvent) {
    event.preventDefault()

    if (await Confirmation.confirm({
      title: "Transfer Ownership?",
      text: "This will transfer the owner role to the selected user. Only the new owner can reverse this change.",
      confirmButtonText: "Yes, transfer ownership",
      cancelButtonText: "No, keep ownership",
      type: "warning"
    })) {
      event.detail.resume(null)
    }
  }
}
